import type { VoidFunctionComponent } from 'react';

import { useDialogContext } from '../../../contexts/DialogContext';
import { useSyncPythonPackages } from '../../../hooks/api/backfills/useSyncPythonPackages';
import Button from '../../generic/Button';
import Card from '../../generic/Card/Card';
import Text from '../../generic/Text';

/**
 * Shows a button to trigger sync of Python packages.
 */
export const SyncPythonPackages: VoidFunctionComponent = () => {
  const { mutate: syncPythonPackages, isPending } = useSyncPythonPackages();
  const { onConfirm } = useDialogContext();

  const onButtonClick = () => {
    onConfirm({
      title: 'Sync Python Packages',
      body: (
        <div>
          Are you sure you want to sync Python packages?
        </div>
      ),
      onConfirm: async () => {
        syncPythonPackages();
      },
    });
  };

  return (
    <Card isFullWidth padding="medium">
      <Card.Header>Sync Python Packages</Card.Header>
      <Card.Content>
        <Text.Paragraph>
          This will queue a background job that syncs Python packages (for manual deps auto-complete).
        </Text.Paragraph>
        <Button onClick={onButtonClick} isDisabled={isPending}>
          Sync
        </Button>
      </Card.Content>
    </Card>
  );
};

export default SyncPythonPackages;
